export default "__VITE_ASSET__BYC5tyvj__"